const RemoveInputIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99997 1.11539C3.90766 1.11539 0.615356 4.40769 0.615356 8.5C0.615356 12.5923 3.90766 15.8846 7.99997 15.8846C12.0923 15.8846 15.3846 12.5923 15.3846 8.5C15.3846 4.40769 12.0923 1.11539 7.99997 1.11539ZM9.50766 8.74616L11.9077 11.1462C12.0307 11.2692 12.0307 11.4538 11.9077 11.5769L11.0461 12.4385C10.923 12.5615 10.7384 12.5615 10.6154 12.4385L8.21536 10.0385C8.09228 9.91539 7.90766 9.91539 7.78459 10.0385L5.38459 12.4385C5.26151 12.5615 5.07689 12.5615 4.95382 12.4385L4.09228 11.5769C3.9692 11.4538 3.9692 11.2692 4.09228 11.1462L6.49228 8.74616C6.61536 8.62308 6.61536 8.43846 6.49228 8.31539L4.06151 5.88462C3.93843 5.76154 3.93843 5.57693 4.06151 5.45385L4.92305 4.59231C5.04613 4.46923 5.23074 4.46923 5.35382 4.59231L7.78459 7.02308C7.90766 7.14616 8.09228 7.14616 8.21536 7.02308L10.6154 4.62308C10.7384 4.5 10.923 4.5 11.0461 4.62308L11.9077 5.48462C12.0307 5.60769 12.0307 5.79231 11.9077 5.91539L9.50766 8.31539C9.41536 8.43846 9.41536 8.62308 9.50766 8.74616Z"
        fill="#4B535F"
      />
    </svg>
  );
};

export default RemoveInputIcon;
